import { Container, Row, Col, Card } from 'react-bootstrap';
import vacanciesData from '../data/vacancies.json';
import { formatDate } from '../utils/dateFormat';

type Vacancy = {
  id: number;
  title: string;
  description: string;
  requirements: string[];
  postedDate: string;
  closingDate: string;
};

function Vacancies() {
  const email = 'info@eastlondonbrass.co.uk'; // Band email address
  const vacancies = vacanciesData.vacancies as unknown as Vacancy[];

  return (
    <Container>
      <h1 className="mb-4 text-white">Vacancies</h1>
      {vacancies.length === 0 ? (
        <Card className="bg-dark text-white">
          <Card.Body>
            <Card.Text className="text-white">
              All positions are currently filled, but if you're interested in joining the band please email us at:{' '}
              <a href={`mailto:${email}`} className="text-accent">{email}</a>{' '}
              and we'll let you know of any suitable opportunities.
            </Card.Text>
          </Card.Body>
        </Card>
      ) : (
        <Row className="g-4">
          {vacancies.map((vacancy) => (
            <Col key={vacancy.id} md={6} lg={4}>
              <Card className="bg-dark text-white">
                <Card.Body>
                  <Card.Title className="text-white">{vacancy.title}</Card.Title>
                  <Card.Subtitle className="mb-2 text-accent">Posted: {formatDate(vacancy.postedDate)}</Card.Subtitle>
                  <Card.Text className="text-white">
                    {vacancy.description}
                  </Card.Text>
                  {vacancy.requirements && vacancy.requirements.length > 0 && (
                    <div className="mt-3">
                      <h6 className="text-accent">Requirements:</h6>
                      <ul className="text-white">
                        {vacancy.requirements.map((requirement: string, index: number) => (
                          <li key={index}>{requirement}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                  <div className="mt-3">
                    <a href={`mailto:${email}?subject=Application for ${vacancy.title}`} className="btn btn-primary">
                      Apply
                    </a>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </Container>
  );
}

export default Vacancies; 